import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { API_BASE_URL } from '../../config/api';

export default function VisitRedirect() {
  const { slug } = useParams();
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/directory/listing/${encodeURIComponent(slug)}`);
        if (!res.ok) throw new Error(`Listing not found (${res.status})`);
        const listing = await res.json();
        const url = /^https?:\/\//i.test(listing.website) ? listing.website : `https://${listing.website}`;
        window.location.replace(url);
      } catch (e) {
        setError(e.message);
      }
    })();
  }, [slug]);

  return (
    <div style={{ padding: 24 }}>
      Redirecting to website... {error && <div style={{ color: '#b00020', marginTop: 8 }}>Error: {error}</div>}
    </div>
  );
}


